module.exports = __webpack_public_path__ + "img/BETVICTOR.21083792.svg";